<template>
	<div>
		<div class="col-lg-12 mb-8">
			<student-profile-tab-placement-placement-booking-table
				:value="props.value"
				:studentProfilePlacementSubTabLists="
					props.studentProfilePlacementSubTabLists
				"
			/>
		</div>

		<div class="col-lg-12 mb-8">
			<student-profile-tab-placement-placement-history-table
				:value="props.value"
				:leadProfilePlacementSubTabLists="
					props.leadProfilePlacementSubTabLists
				"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: "PlacementBooking",
	props: {
		props: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 80px;
}
.mb-8 {
	margin-bottom: 80px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
</style>
